module.exports = __webpack_public_path__ + "static/media/how-it-works-privacy.7e071c0b.png";